module.exports = __webpack_public_path__ + "media/icons/arrow-up-2-787bfe90.png";